module.exports = __webpack_public_path__ + "img/arm-small-X-icon-01.c2666a34.svg";